import React, { useEffect, useState, useRef, lazy, memo } from 'react';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
import { EditorialMethodBox } from '../components/EditorialMethodBox';
import { ImageCarousel } from '../components/ImageCarousel';
import { PremiumOfferSection } from '../components/PremiumOfferSection';
import { ValueStackSection } from '../components/ValueStackSection';
import { FrustrationMethodSection } from '../components/FrustrationMethodSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { CheckCircle2, AlertCircle, Gift, PlayCircle, Star, Clock, ShieldCheck, ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
export function LandingPage() {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const bonusImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/gvoSaTXxkxMoKNmgaHbrNJ/Guia_completa_para_sustitucion_de_ingredientes.png',
    title: 'Guía de Sustitución de Ingredientes',
    subtitle: 'Sustituye con éxito y sin renunciar al sabor'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ooQ7xn6Kcd3i9RdH2HHTAX/Recetas_de_pizza_sin_gluten.png',
    title: 'Recetas de Pizza Sin Gluten',
    subtitle: 'Masa perfecta sin gluten'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/7YyMXGsWB5VaeYapxfWrVs/Recetario_sin_gluten__opciones_deliciosas.png',
    title: '50 Almuerzos y Cenas Sin Gluten',
    subtitle: 'Platos deliciosos y sin riesgos'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ikX66etNbDDmfmXqTRHd4c/Planificador_de_comidas_semanales_con_recetas.png',
    title: 'Planificador de Comidas Semanales',
    subtitle: 'Organiza tus comidas sin gluten'
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % bonusImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [bonusImages.length]);
  const scrollCarousel = (direction: 'left' | 'right') => {
    if (carouselRef.current) {
      const scrollAmount = carouselRef.current.clientWidth;
      carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  // scrollToOffer removed in favor of CartDrawer
  return <div className="min-h-screen bg-[#FFFBEB] text-gray-900 font-inter selection:bg-orange-200" data-id="element-259">
      {/* ANNOUNCEMENT BAR */}
      <div className="sticky top-0 z-50 bg-[#FF8C00] h-[44px] flex items-center overflow-hidden whitespace-nowrap" data-id="element-260">
        <div className="animate-marquee flex items-center gap-0" data-id="element-261">
          {[...Array(6)].map((_, i) => <span key={i} className="font-bold text-black text-sm md:text-base tracking-wide px-8" data-id="element-262">
              🔥 RECIBE +10 BONOS GRATIS SOLO POR HOY
            </span>)}
        </div>
        <div className="animate-marquee2 flex items-center gap-0 absolute" data-id="element-263">
          {[...Array(6)].map((_, i) => <span key={i} className="font-bold text-black text-sm md:text-base tracking-wide px-8" data-id="element-264">
              🔥 RECIBE +10 BONOS GRATIS SOLO POR HOY
            </span>)}
        </div>
      </div>

      <PurchaseNotifications data-id="element-265" />

      {/* PROBLEM & AGITATION SECTION */}
      <section className="py-16 px-4 bg-white/80 pt-[0px] pb-[0px]" data-id="element-266">
        <div className="max-w-2xl mx-auto" data-id="element-267">
          <h2 className="md:text-3xl text-center mb-3 text-gray-900 pt-[17px] pb-[0px] font-[Poppins,_sans-serif] text-[18px] font-[500]" data-id="element-268">
            Si tienes problemas con el azúcar… evita que se dispare después de
            comer (sin dejar el pan, la pizza ni los dulces)
          </h2>
          <p className="text-center md:text-[17px] text-gray-600 mb-8 px-2 font-[Poppins,_sans-serif] font-[300] text-[12px]" data-id="element-269">
            Descubre exactamente qué preparar y cómo hacerlo para reducir picos
            de azúcar en tus comidas… sin dietas estrictas ni sacrificios
            imposibles
          </p>

          <img src="https://cdn.magicpatterns.com/uploads/hcHcRgMTC9Eu6rnB88zuWt/ChatGPT_Image_20_abr_2026,_11_33_51_a.m..png" alt="Volví a comer pan sin que mi azúcar se dispare" className="w-full rounded-xl mb-4" data-id="element-270" />

          {/* Primary CTA — scroll to offer */}
          <div className="flex justify-center mt-4 mb-8" data-id="element-271"></div>

          {/* Dry Bread Problem Image */}
          <div className="mb-10 text-center" data-id="element-272">
            <h3 className="md:text-3xl text-gray-900 mb-5 tracking-tight font-[Merriweather,_serif] text-[24px] font-[800]" data-id="element-273"></h3>
            <div className="grid grid-cols-2 gap-3" data-id="element-274"></div>
          </div>

          {/* Identification Card */}
          <div id="pain-section" className="bg-[#FBF8F1] rounded-[14px] shadow-[0_2px_16px_rgba(0,0,0,0.06)] p-7 md:p-10 mb-10 border border-[#F0EBE0]" data-id="element-275">
            <h3 className="md:text-[22px] font-bold text-gray-900 text-center mb-1 tracking-tight text-[24px] font-[Poppins,_sans-serif]" data-id="element-276">
              Si te pasa esto… necesitas ver esto hoy
            </h3>
            <p className="text-center mb-6" data-id="element-277">
              <span className="text-[#C8A84E] font-semibold md:text-[19px] font-[Roboto,_sans-serif] text-[16px]" data-id="element-278">
                👉 Sientes que tienes que renunciar a todo lo que te gusta por
                tu diabetes?
              </span>
            </p>

            <div className="space-y-5 max-w-lg mx-auto" data-id="element-279">
              {['Comes algo "normal"… y luego te arrepientes por cómo te sientes', 'Has intentado recetas "saludables"… pero no saben igual o no funcionan', 'Terminas frustrada/o porque nada te sale bien y pierdes tiempo y dinero'].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-280">
                  <CheckCircle2 className="w-5 h-5 text-[#7BAE7F] flex-shrink-0 mt-0.5" data-id="element-281" />
                  <p className="text-gray-800 md:text-[16px] text-[16px]" data-id="element-282">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>

          <FrustrationMethodSection data-id="element-283" />
        </div>
      </section>

      {/* Image Carousel - reinforces "Esta guía es para ti" */}
      <div className="pt-6 md:pt-10 bg-white/80" data-id="element-284">
        <p className="text-center text-sm md:text-base text-[#C8A84E] italic font-medium tracking-wide mb-2 px-4" data-id="element-285">
          ✨ Más de 500 recetas probadas por nuestra comunidad
        </p>
        <h2 className="md:text-4xl font-black text-gray-900 uppercase tracking-tight text-center px-4 mb-6 md:mb-8 text-[18px]" data-id="element-286">
          Así es como vas a volver a disfrutar el pan… sin preocuparte después
        </h2>
        <ImageCarousel data-id="element-287" />
      </div>

      {/* HERO SECTION */}
      <section className="px-4 bg-[#FFFBEB] py-2 mt-[8px] mb-0" data-id="element-288">
        <div className="max-w-2xl mx-auto" data-id="element-289">
          <div className="flex justify-center" data-id="element-290">
            <WhatsAppButton text="Sí, quiero mi pack ahora" data-id="element-291" />
          </div>
          <div className="flex justify-center mt-2" data-id="element-292">
            <img src="https://cdn.magicpatterns.com/uploads/1Ma4sTrAHUAYdaEPN8LkAw/30-day-money-back-guarantee-260nw-2631258675.webp" alt="Garantía de devolución de dinero - 7, 10, 15 y 30 días" className="max-w-[200px] w-full opacity-70" loading="lazy" style={{
            mixBlendMode: 'multiply'
          }} data-id="element-293" />
          </div>
        </div>
      </section>

      {/* INSTAGRAM TESTIMONIALS - Social Proof before offer */}
      <section className="py-16 px-4 bg-gradient-to-b from-amber-50 to-orange-50 pt-[0px] pb-[0px]" data-id="element-294">
        <div className="max-w-3xl mx-auto" data-id="element-295">
          {/* Header */}
          <div className="text-center mb-12" data-id="element-296">
            <h2 className="md:text-4xl mb-4 pt-[10px] pb-[10px] text-[20px] text-[#101827] font-[800] font-[Poppins,_sans-serif]" data-id="element-297">
              10.000+ familias ya están logrando resultados reales con estas
              recetas
            </h2>
          </div>

          {/* Auto-scrolling testimonial carousel */}
          <div className="overflow-hidden mb-10 rounded-2xl" data-id="element-298">
            <div className="flex w-max" style={{
            animation: 'carousel-scroll 25s linear infinite'
          }} data-id="element-299">
              {['https://cdn.magicpatterns.com/uploads/kSp91aK3VzGJSKgqcKMpWS/4_ebeba334-e959-42dd-953a-0551addb04f4.webp', 'https://cdn.magicpatterns.com/uploads/wJMa5T77bmTqGDdT88oj8P/14.webp', 'https://cdn.magicpatterns.com/uploads/6mwCQTKV65DhPHiqjkPko6/1_405f5b7a-5e11-4b44-a555-9ee8d6bc1572.webp', 'https://cdn.magicpatterns.com/uploads/kSp91aK3VzGJSKgqcKMpWS/4_ebeba334-e959-42dd-953a-0551addb04f4.webp', 'https://cdn.magicpatterns.com/uploads/wJMa5T77bmTqGDdT88oj8P/14.webp', 'https://cdn.magicpatterns.com/uploads/6mwCQTKV65DhPHiqjkPko6/1_405f5b7a-5e11-4b44-a555-9ee8d6bc1572.webp', 'https://cdn.magicpatterns.com/uploads/kSp91aK3VzGJSKgqcKMpWS/4_ebeba334-e959-42dd-953a-0551addb04f4.webp', 'https://cdn.magicpatterns.com/uploads/wJMa5T77bmTqGDdT88oj8P/14.webp', 'https://cdn.magicpatterns.com/uploads/6mwCQTKV65DhPHiqjkPko6/1_405f5b7a-5e11-4b44-a555-9ee8d6bc1572.webp'].map((src, index) => <div key={index} className="flex-shrink-0 px-2" data-id="element-300">
                  <img src={src} alt="Testimonio de cliente feliz" className="w-72 h-[500px] object-cover rounded-xl shadow-lg" loading="lazy" data-id="element-301" />
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* SOLUTION & OFFER SECTION */}
      <section id="oferta" className="py-16 px-4 bg-amber-50/80 space-y-[10px] pt-0 pb-[0px]" data-id="element-302">
        <div className="max-w-2xl mx-auto pt-0 pb-[15px]" data-id="element-303">
          <div className="text-center mb-4" data-id="element-304"></div>

          <PremiumOfferSection data-id="element-305" />
        </div>
      </section>

      {/* Trust Badges */}
      <div className="px-4 bg-[#FFFBEB] pt-[0px] pb-[0px]" data-id="element-306">
        <div className="max-w-md mx-auto" data-id="element-307"></div>
      </div>

      {/* DEMO SECTION */}
      <section className="py-16 px-4 bg-gray-900 text-white text-center pt-[15px] pb-[15px]" data-id="element-308">
        <div className="max-w-2xl mx-auto bg-[ffff]" data-id="element-309">
          <h2 className="mb-8 pt-[15px] pb-[15px] text-[20px] font-[700] font-[Poppins,_sans-serif]" data-id="element-310">
            👉 Solo hoy: MEGA PACK Anti-Gluten GRATIS — deja de perder dinero en
            recetas que fallan
          </h2>

          {/* Carousel */}
          <div className="relative overflow-hidden mb-8" data-id="element-311">
            <div className="flex transition-transform duration-700 ease-in-out" style={{
            transform: `translateX(-${activeSlide * 100}%)`
          }} data-id="element-312">
              {bonusImages.map((item, index) => <div key={index} className="flex-shrink-0 w-full" data-id="element-313">
                  <div className="rounded-2xl overflow-hidden shadow-2xl border border-gray-700 mb-4 relative" data-id="element-314">
                    <img src={item.src} alt={item.title} className="w-full aspect-square object-cover" loading="lazy" data-id="element-315" />
                    <span className="absolute bottom-3 right-3 bg-red-600 text-white font-black text-sm px-3 py-1.5 rounded-lg shadow-lg uppercase tracking-wide" data-id="element-316">
                      FREE
                    </span>
                  </div>
                  <p className="text-white font-bold text-lg" data-id="element-317">{item.title}</p>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-318">{item.subtitle}</p>
                </div>)}
            </div>

            {/* Dot indicators */}
            <div className="flex justify-center gap-2 mt-4" data-id="element-319">
              {bonusImages.map((_, index) => <button key={index} onClick={() => setActiveSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === activeSlide ? 'bg-amber-500 scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} aria-label={`Ir a slide ${index + 1}`} data-id="element-320" />)}
            </div>
          </div>

          <p className="text-gray-400 italic text-lg" data-id="element-321">
            Esto es más fácil de lo que imaginas 👇
          </p>
        </div>
      </section>

      <EditorialMethodBox data-id="element-322" />

      {/* TESTIMONIALS / OPINIONES VERIFICADAS */}
      <TestimonialSection data-id="element-323" />

      {/* OBJECTIONS & FAQ */}
      <section className="py-16 px-4 bg-white/80 pt-[5px] pb-[5px]" data-id="element-324">
        <div className="max-w-2xl mx-auto" data-id="element-325">
          <h2 className="font-black text-center mb-10 font-[Merriweather,_serif] text-[20px] pt-[14px] pb-[14px]" data-id="element-326">
            ¿Tienes dudas? Te respondo directo:
          </h2>

          <div className="grid gap-4" data-id="element-327">
            <div className="border-2 border-gray-100 rounded-xl p-5 pt-[20px] pb-[20px]" data-id="element-328">
              <h4 className="font-black text-lg flex items-center gap-2 mb-2" data-id="element-329">
                <span className="text-green-500" data-id="element-330">👉</span> ¿Necesito experiencia
                cocinando?
              </h4>
              <p className="text-gray-600" data-id="element-331">
                No. Todo está explicado paso a paso. Funciona desde el primer
                intento.
              </p>
            </div>
            <div className="border-2 border-gray-100 rounded-xl p-5" data-id="element-332">
              <h4 className="font-black text-lg flex items-center gap-2 mb-2" data-id="element-333">
                <span className="text-green-500" data-id="element-334">👉</span> ¿Los ingredientes son
                caros o difíciles de conseguir?
              </h4>
              <p className="text-gray-600" data-id="element-335">
                Para nada. Usamos ingredientes económicos y fáciles de conseguir
                en cualquier mercado.
              </p>
            </div>
            <div className="border-2 border-gray-100 rounded-xl p-5" data-id="element-336">
              <h4 className="font-black text-lg flex items-center gap-2 mb-2" data-id="element-337">
                <span className="text-green-500" data-id="element-338">👉</span> ¿Funciona para
                diabéticos?
              </h4>
              <p className="text-gray-600" data-id="element-339">
                ¡Sí! Las recetas están pensadas para no generar picos de
                insulina.
              </p>
            </div>
            <div className="border-2 border-gray-100 rounded-xl p-5" data-id="element-340">
              <h4 className="font-black text-lg flex items-center gap-2 mb-2" data-id="element-341">
                <span className="text-green-500" data-id="element-342">👉</span> ¿Cómo lo recibo?
              </h4>
              <p className="text-gray-600" data-id="element-343">
                El envío es inmediato por correo. Recibes todo al instante
                después de tu compra.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE BADGE */}
      <section className="py-12 px-4 bg-[#FFFBEB]" data-id="element-344">
        <div className="max-w-lg mx-auto" data-id="element-345">
          <div className="bg-white rounded-2xl shadow-[0_2px_20px_rgba(0,0,0,0.06)] border border-[#F0EBE0] p-8 md:p-10 text-center" data-id="element-346">
            {/* Badge Circle */}
            <div className="mx-auto mb-6 w-28 h-28 rounded-full bg-gradient-to-b from-[#F7D060] to-[#D9A441] flex flex-col items-center justify-center shadow-[0_4px_16px_rgba(217,164,65,0.3)] border-4 border-[#C8A84E]" data-id="element-347">
              <span className="text-[36px] font-black text-gray-900 leading-none" data-id="element-348">
                30
              </span>
              <span className="text-[11px] font-bold text-gray-800 uppercase tracking-wider" data-id="element-349">
                Días
              </span>
              <span className="bg-gray-900 text-[#F7D060] text-[9px] font-black px-3 py-0.5 rounded-sm uppercase tracking-widest mt-0.5" data-id="element-350">
                Garantía
              </span>
            </div>

            {/* Title */}
            <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-4 font-[Merriweather,_serif]" data-id="element-351">
              TU COMPRA ESTÁ{' '}
              <span className="text-[#D9A441]" data-id="element-352">100% PROTEGIDA</span>
            </h3>

            {/* Description */}
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-2" data-id="element-353">
              No quiero tu dinero si este manual no transforma tu cocina. Por
              eso te doy mi{' '}
              <span className="font-bold text-gray-900" data-id="element-354">
                Garantía Blindada de 30 Días
              </span>
              .
            </p>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-5" data-id="element-355">
              Si sentís que no es para vos, nos enviás un correo y te devolvemos
              el{' '}
              <span className="font-bold text-gray-900" data-id="element-356">
                100% de tu inversión
              </span>
              . Sin preguntas, sin vueltas.
            </p>

            {/* Closing line */}
            <p className="text-[#D9A441] font-bold text-sm md:text-base italic" data-id="element-357">
              — El riesgo es todo nuestro.
            </p>
          </div>
        </div>
      </section>

      {/* URGENCY & FINAL CLOSE */}

      {/* Bottom spacer for floating CTA */}
      <div className="h-20" data-id="element-358" />
    </div>;
}